// Same endpoints as the mobile app (src/screens/Notification.js, src/components/NotificationBell.js).
// The notification endpoints answer HTTP 200 with statusType FAILURE/ERROR for business errors.
const unwrap = (data) => {
  if (data?.statusType && data.statusType !== "SUCCESS") {
    throw new Error(data.text || "Request failed");
  }
  return data;
};

export const NOTIFICATION_PAGE_SIZE = 20;

export const createNotificationService = (httpClient) => ({
  // POST /notify/all/user/{userId}  ->  { notifications, totalPage, totalRecord }
  list: async (userId, { page = 1, size = NOTIFICATION_PAGE_SIZE } = {}) => {
    const response = await httpClient.post(`/notify/all/user/${userId}`, {
      page_number: page,
      page_size: size,
      order_by: "DESC",
    });
    const data = unwrap(response.data);
    return {
      notifications: data.notifications || [],
      totalPage: Number(data.totalPage) || 0,
      totalRecord: Number(data.totalRecord) || 0,
    };
  },

  // PUT /notify/setRead (multipart form: notificationId, isRead), as on mobile
  setRead: async (notificationId, isRead = true) => {
    const formData = new FormData();
    formData.append("notificationId", String(notificationId));
    formData.append("isRead", String(isRead));
    const response = await httpClient.put("/notify/setRead", formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return unwrap(response.data);
  },

  // DELETE /notify/delete/{id}
  remove: async (notificationId) => {
    const response = await httpClient.delete(`/notify/delete/${notificationId}`);
    return unwrap(response.data);
  },

  // GET /notify/getCount  ->  totalRecord = number of UNREAD notifications of the caller
  getUnreadCount: async () => {
    const response = await httpClient.get("/notify/getCount");
    return Number(unwrap(response.data).totalRecord) || 0;
  },
});
